import { WordpressMenuItem } from "~/models/menu";
import { MegaMenu } from "./MegaMenu";
import { MobileMenu } from "./MobileMenu";
import { Logger } from "~/utils/logger";
const logger = new Logger("menu", "info");

export function Menu(props: {
  id: number;
  items: WordpressMenuItem[];
  type: "desktop" | "mobile";
}) {
  logger.debug("props:", props);

  // the megamenu items come in as a flat array, turn it into a tree structure for easier rendering
  function buildMenuTree(
    items: WordpressMenuItem[],
    parentId: number = 0,
  ): any[] {
    return items
      .filter((item) => Number(item.parentId) === parentId)
      .map((item) => ({
        ...item,
        children: buildMenuTree(items, item.id),
      }));
  }

  if (!props || !props.items || props.items.length === 0) {
    return <p>No menu items found.</p>;
  }

  const menuTree = buildMenuTree(props.items);
  logger.debug("tree structure:", menuTree);

  if (props.type === "mobile") {
    return <MobileMenu id={props.id} items={menuTree} />;
  }

  return <MegaMenu id={props.id} items={menuTree} />;
}
